export default "__VITE_ASSET__c9028fbd__"